var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.51001H1C0.734784 0.51001 0.48043 0.615367 0.292893 0.802903C0.105357 0.990439 0 1.24479 0 1.51001V11.51C0 11.7752 0.105357 12.0296 0.292893 12.2171C0.48043 12.4047 0.734784 12.51 1 12.51H15C15.2652 12.51 15.5196 12.4047 15.7071 12.2171C15.8946 12.0296 16 11.7752 16 11.51V1.51001C16 1.24479 15.8946 0.990439 15.7071 0.802903C15.5196 0.615367 15.2652 0.51001 15 0.51001ZM14.23 11.51H1.83L5.33 7.89001L4.61 7.19501L1 10.93V2.27001L7.215 8.45501C7.40236 8.64126 7.65581 8.7458 7.92 8.7458C8.18419 8.7458 8.43764 8.64126 8.625 8.45501L15 2.11501V10.865L11.32 7.18501L10.615 7.89001L14.23 11.51ZM1.655 1.51001H14.19L7.92 7.74501L1.655 1.51001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/Communications.4769b7e6869d9a17e39a33757be4ceca.svg";
export { ForwardRef as ReactComponent };